type BrandMarkProps = {
  size?: "sm" | "lg";
};

export default function BrandMark({ size = "sm" }: BrandMarkProps) {
  const isLg = size === "lg";
  return (
    <div className="flex items-center gap-2.5">
      <div
        className={`relative flex items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 text-background-50 ${
          isLg ? "h-11 w-11" : "h-9 w-9"
        }`}
      >
        <i className={`ri-play-fill ${isLg ? "text-2xl" : "text-xl"}`}></i>
        <span className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-secondary-500 ring-2 ring-background-50"></span>
      </div>
      <div className="flex flex-col leading-none">
        <span
          className={`font-heading font-black tracking-tight text-foreground-950 ${
            isLg ? "text-xl" : "text-lg"
          }`}
        >
          糖豆视频
        </span>
        <span className="mt-0.5 font-label text-[10px] uppercase tracking-[0.32em] text-foreground-500">
          Tangdou
        </span>
      </div>
    </div>
  );
}